import React from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

function LoadingButton({ isLoading, children, onChange }) {
  return (
    <Button
      variant="primary"
      disabled={isLoading}
      isLoading={isLoading}
      onClick={onChange}
    >
      {isLoading ? (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      ) : null}
      {children}
    </Button>
  );
}

export default LoadingButton;
